import {createSelector} from 'reselect';
import {
    getListingPage
} from './store';
import {OpenModalStates} from '../records/listingPageRecord';

const isDatePickerModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER) ||
                (openModalState === OpenModalStates.INQUIRY_DATE_PICKER) ||
                (openModalState === OpenModalStates.MAIN_PAGE_DATE_PICKER) ||
                (openModalState === OpenModalStates.BOOKING_FLOW_DATE_PICKER);
    }
);

const isGuestSelectorModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR) ||
                (openModalState === OpenModalStates.INQUIRY_GUEST_SELECTOR) ||
                (openModalState === OpenModalStates.MAIN_PAGE_GUEST_SELECTOR) ||
                (openModalState === OpenModalStates.BOOKING_FLOW_GUEST_SELECTOR);
    }
);

const isRequestToBookModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.REQUEST_TO_BOOK) ||
        (openModalState === OpenModalStates.REQUEST_TO_BOOK_DATE_PICKER) ||
        (openModalState === OpenModalStates.REQUEST_TO_BOOK_GUEST_SELECTOR);
    }
);

const isInquiryModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.INQUIRY) ||
        (openModalState === OpenModalStates.INQUIRY_DATE_PICKER) ||
        (openModalState === OpenModalStates.INQUIRY_GUEST_SELECTOR);
    }
);

const isLoginModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.LOGIN_EXPERIENCE);
    }
);

const isInquiryLoginModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.INQUIRY_LOGIN_EXPERIENCE);
    }
);

const isLocationModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.LOCATION;
    }
);

const isMapModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.MAP;
    }
);

const isCivilCodeDisclaimerModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.CIVIL_CODE_DISCLAIMER;
    }
);

const isDescriptionModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.DESCRIPTION;
    }
);

const isUnitDescriptionModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.UNIT_DESCRIPTION;
    }
);

const isReviewsModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.REVIEWS;
    }
);

const isAmenityModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.AMENITY;
    }
);

const isOwnerProfileModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.OWNER_PROFILE;
    }
);

const isSearchModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.SEARCH ||
                openModalState === OpenModalStates.SEARCH_DATE_PICKER ||
                openModalState === OpenModalStates.SEARCH_GUEST_PICKER;
    }
);

const isSearchDatePickerOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.SEARCH_DATE_PICKER;
    }
);

const isSearchGuestPickerOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return openModalState === OpenModalStates.SEARCH_GUEST_PICKER;
    }
);

const isVirtualTourModalOpen = createSelector(
    [getListingPage],
    (listingPage) => {
        const {
            openModalState
        } = listingPage;

        return (openModalState === OpenModalStates.VIRTUAL_TOUR);
    }
);

const getListingPageModalStates = createSelector([
    getListingPage,
    isCivilCodeDisclaimerModalOpen,
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen,
    isLoginModalOpen,
    isInquiryLoginModalOpen,
    isLocationModalOpen,
    isMapModalOpen,
    isDescriptionModalOpen,
    isUnitDescriptionModalOpen,
    isReviewsModalOpen,
    isAmenityModalOpen,
    isSearchModalOpen,
    isSearchDatePickerOpen,
    isSearchGuestPickerOpen,
    isVirtualTourModalOpen
], (
    listingPage,
    civilCodeDisclaimerModalOpen,
    datePickerModalOpen,
    guestSelectorModalOpen,
    requestToBookModalOpen,
    inquiryModalOpen,
    loginModalOpen,
    inquiryLoginModalOpen,
    locationModalOpen,
    mapModalOpen,
    descriptionModalOpen,
    unitDescriptionModalOpen,
    reviewsModalOpen,
    amenityModalOpen,
    searchModalOpen,
    searchDatePickerOpen,
    searchGuestPickerOpen,
    virtualTourModalOpen
) => {
    return {
        civilCodeDisclaimerModalOpen,
        datePickerModalOpen,
        guestSelectorModalOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        loginModalOpen,
        inquiryLoginModalOpen,
        locationModalOpen,
        mapModalOpen,
        descriptionModalOpen,
        unitDescriptionModalOpen,
        reviewsModalOpen,
        amenityModalOpen,
        searchModalOpen,
        searchDatePickerOpen,
        searchGuestPickerOpen,
        virtualTourModalOpen
    };
});

export default getListingPageModalStates;
export {
    getListingPageModalStates,
    isCivilCodeDisclaimerModalOpen,
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen,
    isLocationModalOpen,
    isMapModalOpen,
    isDescriptionModalOpen,
    isUnitDescriptionModalOpen,
    isReviewsModalOpen,
    isAmenityModalOpen,
    isOwnerProfileModalOpen,
    isVirtualTourModalOpen
};
